module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(getWidgetType().indexOf('photowall') !== -1) { ;
__p += '\n<div id="results_counter">\n	<span id="results_count">0</span>\n</div>\n';
 } else { ;
__p += '\n<div id="results_counter" class="hidden">0</div>\n';
 } ;
__p += '\n<div id="filter_item_region"></div>\n<div id="clear_all_button"></div>';

}
return __p
}